// extracted by mini-css-extract-plugin
module.exports = {"root":"Vertical_root__1QEqt","vl":"Vertical_vl__3gfEz","threeDots":"Vertical_threeDots__3h9Y9"};